import { render } from "./PredictionAwaits.vue?vue&type=template&id=e27b451e"
import script from "./PredictionAwaits.vue?vue&type=script&lang=js"
export * from "./PredictionAwaits.vue?vue&type=script&lang=js"

import "./PredictionAwaits.vue?vue&type=style&index=0&id=e27b451e&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__